import { AbstractControl } from "@angular/forms";

export function latvianPersonalNumberValidator(control: AbstractControl): { format?: boolean } | null {
	const value = String(control.value);
	const oldPersonalNumberRegex = /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[012])(\d{2})-?(0|1|2)(\d{4})$/;
	const newPersonalNumberRegex = /^(32)(\d{4})-?(\d{5})$/;

	if (value.match(newPersonalNumberRegex)) {
		return null;
	}
	if (value.match(oldPersonalNumberRegex)) {
		const valueToCheck = value.replace("-", "");
		const multipliers = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
		const total = multipliers
			.map((multiplier, index) => Number(valueToCheck.charAt(index)) * multiplier)
			.reduce((acc, val) => acc + val);

		const expectedValue = ((1101 - total) % 11) % 10;

		if (expectedValue === Number(valueToCheck.charAt(valueToCheck.length - 1))) {
			return null;
		}
	}

	return { format: false };
}
